// styled-components based extension
import styled, { css } from 'styled-components'
import { Flex } from '@magicsoup.io/stock'

const Square = styled(Flex)`
  :before {
    content: '';
    display: block;
    float: left;
    padding-top: 100%;
  }
`

Square.defaultProps = {
  as: 'div',
}

export default Square